import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../../services/apiService';

const FETCH_CRYPTO_CURRENCIES = 'criptoWallet/fetchCryptoCurrencies';
const FETCH_NETWORKS_BY_CRYPTO = 'criptoWallet/fetchNetworksByCrypto';
const VALIDATE_WALLET = 'criptoWallet/validateWallet';

// Obtener criptomonedas
export const fetchCryptoCurrencies = createAsyncThunk(
  FETCH_CRYPTO_CURRENCIES,
  async (payload, { rejectWithValue }) => {
    const { token } = payload;
    const url = '/crypto-currencies';
    
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const response = await get(url, config);
      const currencies = response.data.map(currency => ({
        value: currency.code,
        label: currency.symbol
      }));
      
      return currencies;
    } catch (error) {
      console.error('Error fetching crypto currencies thunk:', error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Obtener networks por criptomoneda
export const fetchNetworksByCrypto = createAsyncThunk(
  FETCH_NETWORKS_BY_CRYPTO,
  async (payload, { rejectWithValue }) => {
    const { token, cryptoCode } = payload;
    const url = `/crypto-currencies/${cryptoCode}/info`;
    
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const response = await get(url, config);

      const networks = response.networks.map(network => ({
        value: network.code,
        label: network.name
      }));
      
      return networks;
    } catch (error) {
      console.error('Error fetching networks thunk:', error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Validar wallet
export const validateWallet = createAsyncThunk(
  VALIDATE_WALLET,
  async (payload, { rejectWithValue }) => {
    const { token, walletData } = payload;
    const url = '/crypto-currencies/validate-wallet';
    
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const response = await post(url, {
        wallet_address: walletData.wallet_address,
        crypto_currency_code: walletData.crypto_currency_code
      }, config);
      
      return response;
    } catch (error) {
      console.error('Error validating wallet thunk:', error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);